import { namespace } from "./global"

/** 主题模式 */
export enum ThemeEnum {
	/**跟随系统 */
	AUOT = "auto",
	/**暗色主题 */
	DARK = "dark",
	/**亮色主题 */
	LIGHT = "light"
}

/** 主题设置 */
export interface ThemeSetting {
	/** 主题	 */
	theme: ThemeEnum
	/** 主题颜色 */
	themeColor: string
	/** 主题名称 */
	themeName: string
	/** 命名空间 */
	namespace: string
}

/** 主题颜色选项 */
export const colorOptions = {
	/** 默认主题颜色 */
	default: "#1677ff",
	/** 绿色 */
	green: "#00b96b",
	/** 大气红 */
	red: "#c30d23",
	/** 热卖红 */
	hotRed: "#ff4d4d",
	/** 活力橙 */
	orange: "#ff6701",
	/** 优雅金 */
	gold: "#d2be8f",
	/** 雅致绿 */
	lightGreen: "#6bbec1",
	/** 人气紫 */
	purple: "#7c5dfe",
	/** 办公蓝 */
	officeBlue: "#5798db",
	/** 高亮蓝 */
	deepBlue: "#027aff",
	/** 懂微蓝 */
	origin: "#3b4a56",
	/** 高级黑 */
	black: "#4c4747"
}

/** 默认主题 */
export const themeSetting: ThemeSetting = {
	themeName: "default",
	themeColor: colorOptions.default,
	namespace: namespace,
	theme: ThemeEnum.AUOT
}
